module.exports = {
  PENDING: 'pending',
  SPONSORED: 'sponsored',
  REWARDED: 'rewarded',
};
